import React from 'react'
import ConditionalWrapper from './ConditionalWrapper'
import { Text } from 'library/atoms/Typography'
import { Formik } from 'formik'
import {
  StyleGuideMain,
  StyleGuideIdProps
} from 'shared/library/pages/StyleGuide'

const PROPS = {
  Description: () => (
    <Text>
      Input is used in place of a traditional `input` element. This has formik
      baked into it for ease of use.
    </Text>
  ),
  examples: [
    {
      title: 'If condition is true',
      code: `<ConditionalWrapper
  condition={true}
  wrapper={children => {
    return (
      <div>
        <h2>This is the wrapper</h2>
        {children}
      </div>
    )
  }}
>
  <p>This is the child component</p>
</ConditionalWrapper>
    `,
      scope: { Formik, ConditionalWrapper }
    },
    {
      title: 'If condition is false',
      code: `<ConditionalWrapper
  condition={false}
  wrapper={children => {
    return (
      <div>
      <h2>This is the wrapper</h2>
        {children}
      </div>
    )
  }}
>
  <p>This is the child component</p>
</ConditionalWrapper>
`,
      scope: { Formik, ConditionalWrapper }
    }
  ]
}

const ConditionalWrapperStyleGuide = (props: StyleGuideIdProps) => (
  <StyleGuideMain {...props} {...PROPS} />
)

export default ConditionalWrapperStyleGuide
